import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const cancelPickSession = {
  name: "cancelPickSession" as const,
  input: z.object({ pickSessionId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    // Populated when this session consolidated upstream handoffs. Each
    // entry is a tote the picker physically holds that must be returned
    // to its destination zone so another picker can claim the restored
    // HANDED_OFF session.
    restoredHandoffs: z
      .array(
        z.object({
          toteId: zExt.objectId(),
          toteName: z.string(),
          returnZoneId: z.string(),
          returnZoneName: z.string(),
        }),
      )
      .optional(),
  }),
};
